import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {
  IImportParcel,
  INewParcel,
  IPostParcel,
  IPostParcelList
} from '../../shared/model/interface/post-parcel.model.interface';
import {IPostOutboxBookList} from '../../shared/model/interface/post-outbox-book.model.interface';
import {WebsocketService} from './websocket.service';
import {PostParcelsObservableMapper} from '../../shared/mapper/post-parcel-observable.mapper';
import {map} from 'rxjs/operators';
import {IObjectList} from '../../shared/model/interface/object-list.model.interface';
import {
  IParcelContentType,
  IParcelContentTypeList
} from '../../shared/model/interface/parcel-content-type.model.interface';
import {
  IPostOutboxBookBuffer
} from '../../shared/model/interface/post-outbox-book-buffer.model.interface';
import {Observable, Subject} from 'rxjs';
import {IParcelType, IParcelTypeList} from '../../shared/model/interface/parcel-type.model.interface';
import {PageEvent} from '@angular/material/paginator';
import {HttpParamsFactory} from '../../shared/factory/http-params.factory';
import {IEnveloParcelList} from "../../shared/model/interface/envelo-parcel.model.interface";

@Injectable({
  providedIn: 'root'
})
export class PostService {

  constructor(private http: HttpClient,
              private websocketService: WebsocketService,
              private postParcelsObservableMapper: PostParcelsObservableMapper) {
  }

  private static readonly BACKEND_URL = environment.backendUrl;
  private static readonly IMPORTER_URL = environment.importerUrl
  private subject = new Subject<any>();

  createShipmentToDebtor(legalCaseId: number, departmentId: number, newParcel: INewParcel) {
    return this.http.post<IPostParcel>(PostService.BACKEND_URL + `/legal-cases/${legalCaseId}/parcels`,
      newParcel);
  }

  importParcelsToCreate(importParcel: IImportParcel) {
    return this.http.post<IPostParcel>(PostService.IMPORTER_URL + `/import/post`,
      importParcel);
  }

  getPostParcelsForLegalCase(legalCaseId: number, departmentId: number) {
    return this.http.get<IPostParcelList>(PostService.BACKEND_URL + `/legal-cases/${legalCaseId}/parcels`);
  }

  getOutboxBooks(event: PageEvent) {
    const params = HttpParamsFactory.fromPageEvent(event);
    return this.http.get<IPostOutboxBookList>(PostService.BACKEND_URL + '/outbox-books', { params });
  }

  getEnveloParcels(event: PageEvent) {
    const params = HttpParamsFactory.fromPageEvent(event);
    return this.http.get<IEnveloParcelList>(PostService.BACKEND_URL + '/envelo-parcels', { params });
  }

  getEpoUserBuffers() {
    return this.http.get<IPostOutboxBookBuffer>(PostService.BACKEND_URL + '/buffer/epo/user');
  }

  getEpoSystemBuffers() {
    return this.http.get<IPostOutboxBookBuffer>(PostService.BACKEND_URL + '/buffer/epo/system');
  }

  getRegularUserBuffers() {
    return this.http.get<IPostOutboxBookBuffer>(PostService.BACKEND_URL + '/buffer/regular/user');
  }

  getRegularSystemBuffers() {
    return this.http.get<IPostOutboxBookBuffer>(PostService.BACKEND_URL + '/buffer/regular/system');
  }

  getEnveloUserBuffers() {
    return this.http.get<IPostOutboxBookBuffer>(PostService.BACKEND_URL + '/buffer/envelo/user');
  }

  getEnveloSystemBuffers() {
    return this.http.get<IPostOutboxBookBuffer>(PostService.BACKEND_URL + '/buffer/envelo/system');
  }

  sendUserEpoParcels(): Observable<object> {
    return this.http.post(PostService.BACKEND_URL + `/outbox-books/user/epo`, null);
  }

  sendSystemEpoParcels(): Observable<object> {
    return this.http.post(PostService.BACKEND_URL + `/outbox-books/system/epo`, null);
  }

  sendUserRegularParcels(): Observable<object> {
    return this.http.post(PostService.BACKEND_URL + `/outbox-books/user/regular`, null);
  }

  sendSystemRegularParcels(): Observable<object> {
    return this.http.post(PostService.BACKEND_URL + `/outbox-books/system/regular`, null);
  }

  subscribeToParcels(legalCaseId: number) {
    const subscription = this.websocketService.subscribeToParcels(legalCaseId);
    return this.postParcelsObservableMapper.fromWebsocketMessage(subscription);
  }

  fetchAllParcelContentTypes(strategyAllowed?: boolean) {
    let params = new HttpParams();
    if (strategyAllowed !== undefined) {
      params = params.set('strategyAllowed', strategyAllowed);
    }

    return this.http.get<IObjectList<IParcelContentType>>(PostService.BACKEND_URL + '/parcels/content-types', {
      params
    })
      .pipe(
        map(data => new IParcelContentTypeList(data))
      );
  }

  fetchAllParcelTypes() {
    return this.http.get<IObjectList<IParcelType>>(PostService.BACKEND_URL + '/parcels/shipping-ways')
      .pipe(
        map(data => new IParcelTypeList(data))
      );
  }

  updateOutboxBooks() {
    this.subject.next(`Wysłane`)
  }
}
